<script lang="ts">
  import { getContext, onMount } from "svelte";
  import * as _ from "lodash-es";
  import { twMerge } from "tailwind-merge";
  import type { createFormStore } from "../store";

  export let wrapperClassname = "";
  export let help = ""; // help text
  export let id: string | undefined = undefined;
  export let label: string | undefined = undefined;
  export let labelHidden = false;
  export let name: string;
  export let inputWrapperClass = "";
  export let labelClassname = "";
  export let validationRules: { [key: string]: any } = {};

  const formStore: ReturnType<typeof createFormStore> = getContext("form");
  label = label ?? _.capitalize(_.startCase(name)); // displayName to Display name

  $: error = $formStore?.errors[name];

  onMount(() => {
    if (formStore) {
      formStore.addValidationRules(name, validationRules);
    }
  });
</script>

<div class={twMerge("mb-6 flex w-auto flex-col gap-2", wrapperClassname)} aria-label={label}>
  {#if label && !labelHidden}
    <label
      for={id}
      class={twMerge(
        "block text-base font-medium text-neutral-900 dark:text-white",
        error && "text-danger text-red-400 dark:text-red-400",
        labelClassname
      )}
    >
      <h3 class="text-sm font-medium text-neutral-600 sm:text-[13px] dark:text-neutral-300">
        {label}
      </h3>
    </label>
  {/if}
  <div class={twMerge("flex size-full flex-col", inputWrapperClass)}>
    {#if help}
      <span class="mb-2 block text-xs font-normal text-neutral-400 dark:text-neutral-400/80">
        {help}
      </span>
    {/if}
    <slot />
    {#if error}
      <span class="mt-3 inline-block text-red-400 sm:text-sm dark:text-red-400">
        {error?.message}
      </span>
    {/if}
  </div>
</div>
